const deepFind = (obj, path) => {
  const keys = path.split('.');
  return keys.reduce((acc, key) => (
    acc[key] ? acc[key] : false
  ), obj);
};

export default deepFind;
